import { ScenarioTemplateGridMenuProps } from '@/interfaces/scenarioBuilder.interface'
import MenuIcon from '@mui/icons-material/Menu'
import { IconButton, Menu, MenuItem } from '@mui/material'
import React from 'react'

const ScenarioTemplateGridMenu: React.FC<ScenarioTemplateGridMenuProps> = ({
  isReadonly,
  onDeleteRow,
  tableIdentifier,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  // Handlers
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleMenuItemClick = (action: () => void) => () => {
    action()
    handleClose()
  }
  const handleDeleteScenario = () => {
    onDeleteRow()
  }

  return (
    <>
      <IconButton
        disabled={isReadonly}
        id='action-button'
        aria-controls={open ? 'action-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref={(ref: any) => {
          if (!ref) return
          ref.onclick = (e: MouseEvent) => {
            e.stopPropagation()
            setAnchorEl(ref)
          }
        }}
      >
        <MenuIcon fontSize='small' sx={{ fontSize: '16px' }} />
      </IconButton>
      <Menu
        id='action-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'action-button',
        }}
        data-cy='scenario-template-grid-menu-icon-button'
      >
        <MenuItem onClick={handleMenuItemClick(() => handleDeleteScenario())}>
          Delete {tableIdentifier}
        </MenuItem>
      </Menu>
    </>
  )
}

export default ScenarioTemplateGridMenu
